// Persistent Google Maps loader that survives component unmounts
class PersistentGoogleMapsLoader {
  constructor() {
    this.isLoaded = false;
    this.isLoading = false;
    this.callbacks = [];
    this.apiKey = 'AIzaSyCsEuLdHnu5Iyo1xtAe0xg-VGlZ0_xWyhs';
  }

  load() {
    return new Promise((resolve, reject) => {
      console.log('PersistentGoogleMapsLoader: Load requested, current state:', {
        isLoaded: this.isLoaded,
        isLoading: this.isLoading,
        hasGoogle: !!(window.google && window.google.maps)
      });

      // If already loaded, resolve immediately
      if (this.isLoaded && window.google && window.google.maps) {
        console.log('PersistentGoogleMapsLoader: Already loaded, resolving immediately');
        resolve(window.google.maps);
        return;
      }

      // Add callback to queue
      this.callbacks.push({ resolve, reject });
      console.log('PersistentGoogleMapsLoader: Added callback to queue, total callbacks:', this.callbacks.length);

      // If already loading, just wait
      if (this.isLoading) {
        console.log('PersistentGoogleMapsLoader: Already loading, waiting...');
        return;
      }

      // Check if script already exists
      const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
      if (existingScript) {
        console.log('PersistentGoogleMapsLoader: Script already exists, waiting for it to load...');
        this.waitForGoogleMaps();
        return;
      }

      // Start loading
      this.isLoading = true;
      console.log('PersistentGoogleMapsLoader: Starting to load Google Maps...');

      // Create script element
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places&callback=initPersistentGoogleMaps`;
      script.async = true;
      script.defer = true;

      // Set up global callback
      window.initPersistentGoogleMaps = () => {
        console.log('PersistentGoogleMapsLoader: Global callback triggered');
        this.isLoaded = true;
        this.isLoading = false;
        
        // Resolve all pending callbacks
        console.log('PersistentGoogleMapsLoader: Resolving', this.callbacks.length, 'callbacks');
        this.callbacks.forEach(({ resolve }) => {
          resolve(window.google.maps);
        });
        this.callbacks = [];
        
        // Clean up global callback
        delete window.initPersistentGoogleMaps;
      };

      script.onerror = (error) => {
        console.error('PersistentGoogleMapsLoader: Script loading failed:', error);
        this.isLoading = false;
        const loadError = new Error('Failed to load Google Maps API');
        
        // Reject all pending callbacks
        this.callbacks.forEach(({ reject }) => {
          reject(loadError);
        });
        this.callbacks = [];
      };

      console.log('PersistentGoogleMapsLoader: Appending script to document head');
      document.head.appendChild(script);
    });
  }

  waitForGoogleMaps() {
    console.log('PersistentGoogleMapsLoader: Waiting for existing Google Maps script to load...');
    let checkCount = 0;
    const maxChecks = 100; // 10 seconds max
    
    const checkGoogleMaps = () => {
      checkCount++;
      console.log(`PersistentGoogleMapsLoader: Check ${checkCount}/${maxChecks} for Google Maps availability`);
      
      if (window.google && window.google.maps) {
        console.log('PersistentGoogleMapsLoader: Google Maps found!');
        this.isLoaded = true;
        this.isLoading = false;
        
        // Resolve all pending callbacks
        this.callbacks.forEach(({ resolve }) => {
          resolve(window.google.maps);
        });
        this.callbacks = [];
      } else if (checkCount < maxChecks) {
        // Check again in 100ms
        setTimeout(checkGoogleMaps, 100);
      } else {
        console.error('PersistentGoogleMapsLoader: Timeout waiting for Google Maps to load');
        this.isLoading = false;
        const error = new Error('Timeout waiting for Google Maps to load');
        this.callbacks.forEach(({ reject }) => reject(error));
        this.callbacks = [];
      }
    };
    
    checkGoogleMaps();
  }
}

// Export singleton instance
export const persistentGoogleMapsLoader = new PersistentGoogleMapsLoader();
export default persistentGoogleMapsLoader;
